import { checkIsChangelog } from '../../helpers/changelog/path'

export const buildNavGroup = (navYaml, allFile, page, lang) => {
  const { menu } = navYaml.nav
  const menuItems = menu || []
  const allPages = {}
  const WEBHOOK_PAGES_WITH_MULTI_VERSION = [
    'cancel-subscription-webhook',
    'switch-plan-webhook',
    'cart-abandonment-webhook',
    'purchase-webhook',
  ]

  allFile.edges.forEach(({ node }) => {
    const { slug } = node.childMarkdownRemark.fields

    if (!checkIsChangelog(slug) && node.childMarkdownRemark.fields.langKey === lang) {
      let route = page === slug ? slug : WEBHOOK_PAGES_WITH_MULTI_VERSION.includes(node.name) ? slug.replace('/1.0.0/', '/2.0.0/') : slug

      allPages[node.name] = {
        title: node.childMarkdownRemark.frontmatter.title,
        slug: route,
      }
    }
  })

  const categories = menuItems.map(({ items, category }) => {
    const catItems = []

    items.forEach(({ page }) => {
      allPages[page] && catItems.push(allPages[page])
    })
    return { category, items: catItems }
  })

  return categories
}
